module.exports = __webpack_public_path__ + "img/helen-half.300f9fd2.png";